import * as types from './mutations-types'

export default {
  [types.setAccessUser] (state, accessUser) {
    state.accessUser = accessUser
  },
  [types.setAccessUsers] (state, accessUsers) {
    state.accessUsers = accessUsers
  },
  [types.clearUsers] (state) {
    state.users = []
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/access_users/vuex/mutations.js